import { ControlSizesSM, InlineButton, InlineButtonAlignments } from '@picsart/inlineButton';
import { ElementType } from 'react';

import useStyles from './styles';

interface IListItemProps {
  isActive: boolean;
  Icon: ElementType;
  text: string;
  onClick: () => void;
  dataTestId?: string;
}

const ListItem = ({ isActive, Icon, text, onClick, dataTestId }: IListItemProps) => {
  const classes = useStyles();

  return (
    <InlineButton
      data-testid={dataTestId}
      alignment={InlineButtonAlignments.Start}
      className={classes.widgetButton}
      isActive={isActive}
      onClick={onClick}
      startIcon={Icon}
      size={ControlSizesSM}
      isWithoutBorder
      isWithoutBackground
    >
      {text}
    </InlineButton>
  );
};

export default ListItem;
